module.exports = __webpack_public_path__ + "img/card.d9eff967.png";